import { Sparkles } from "lucide-react";
import { Link, useLocation } from "react-router-dom";
import { useAdEligibility } from "@/hooks/useAdEligibility";
import { cn } from "@/lib/cn";
import { isAdSenseConfigured, isAdvertisingSupportedPath } from "@/lib/adsense";

export function AdFreeUpsell({ className = "" }: { className?: string }) {
  const { isResolved, shouldShowAds } = useAdEligibility();
  const { pathname } = useLocation();

  if (
    !isResolved ||
    !shouldShowAds ||
    !isAdSenseConfigured() ||
    !isAdvertisingSupportedPath(pathname)
  ) {
    return null;
  }

  return (
    <aside
      className={cn(
        "flex flex-col gap-3 border border-ice/15 bg-ice/[0.04] px-4 py-3 sm:flex-row sm:items-center sm:justify-between",
        className,
      )}
      aria-label="Ad-free subscription"
    >
      <div className="flex items-center gap-2.5 text-xs text-white/48">
        <Sparkles className="h-4 w-4 shrink-0 text-ice" />
        <span>Prefer Tackle Four without advertising?</span>
      </div>
      <Link
        to="/profile#subscription"
        className="text-xs font-bold text-ice transition-colors hover:text-white"
      >
        Remove ads with Plus
      </Link>
    </aside>
  );
}
